angular
	.module 'App.Module.Kpi', []
	.config ($stateProvider) ->
		$stateProvider
			.state 'reports.kpi',
					url: '/kpi'
					views:
						"main@":
							controller: 'KpiController'
							templateUrl: '@app/kpi/kpi.view.html'
					data:
						require_login: true
						hideSubMenu: true
						pageTitle: 'Kpi'
						restrict: "Backoffice.TopMenu.Report.Kpi"
